// extracted by mini-css-extract-plugin
module.exports = {"cvLogin":"style__cvLogin__s6++F"};